import React, { useState } from 'react';
import { DatePicker, Form } from 'antd';
import type { Moment } from 'moment';

import { DATE_FORMAT_SHORT } from '../../../utils/date';

type DateInputProps = {
  name: string;
  label: string;
  value?: Moment;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: Moment | null) => void;
  extra?: React.ReactNode;
};

export function DateInput(props: DateInputProps) {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  const handleChange = (value: Moment | null) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };

  return (
    <>
      <Form.Item name={props.name} label={props.label} rules={[{ required: props.required, message: `${props.label} is required` }]} extra={props.extra}>
        <DatePicker
          format={DATE_FORMAT_SHORT}
          open={isDatePickerOpen}
          onBlur={() => setIsDatePickerOpen(false)}
          onOpenChange={(isOpen) => setIsDatePickerOpen(isOpen)}
          placeholder="DD/MM/YYYY"
          style={{ width: '100%' }}
          value={props.value}
          onChange={handleChange}
          disabled={props.disabled}
        />
      </Form.Item>
    </>
  );
}
